import * as types from "./types";

const editorAnglesReducer = (state: types.State, action: types.Action): types.State => {
    switch (action.type) {
        case types.SET_EDITOR_ANGLES: {
            return { ...state, angles: action.angles };
        }
        case types.SET_EDITOR_SELECTED_ANGLES: {
            return { ...state, selectedAngles: action.selectedAngles };
        }
        case types.SET_EDITOR_DROPDOWN_ANGLES: {
            return { ...state, dropdownAngles: action.dropdownAngles };
        }
        case types.SET_EDITOR_INITIALISED_ANGLES: {
            return { ...state, anglesInitialised: action.anglesInitialised};
        }
        case types.SET_EDITOR_ANGLES_AUDIO: {
            const newAnglesAudio = typeof action.anglesAudio === "function"
                ? action.anglesAudio(state.anglesAudio)
                : action.anglesAudio;

            return { ...state, anglesAudio: newAnglesAudio };
        }
        case types.SET_EDITOR_AUDIO_PLAYER_READY: {
            return { ...state, audioPlayerReady: action.audioPlayerReady };
        }
        default: {
            throw new Error(`Unhandled action type`);
        }
    }
}

export default editorAnglesReducer;